module.exports = __webpack_public_path__ + "static/lighthouse-100percent-b80ebf716c3ddf4ada36524a0a5177e3.jpg";